import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-brand-primary to-accent text-white overflow-hidden">
      <div className="absolute inset-0 bg-black/10"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="flex items-center justify-center w-12 h-12 bg-white/20 rounded-lg backdrop-blur-sm">
                  <Icon name="Scale" size={24} color="white" strokeWidth={2.5} />
                </div>
                <span className="text-lg font-semibold text-white/90">
                  ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH
                </span>
              </div>
              <h1 className="text-4xl lg:text-6xl font-bold leading-tight">
                Über AdvoCall
                <span className="block text-conversion-accent">Die Telefonberatung</span>
              </h1>
              <p className="text-xl text-white/90 leading-relaxed max-w-2xl">
                Rechtliche Expertise zugänglich gemacht - wir durchbrechen die einschüchternden Barrieren traditioneller Rechtsberatung durch sofortige, professionelle telefonische Beratung.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                iconName="Phone"
                iconPosition="left"
                className="bg-conversion-accent hover:bg-cta text-white cta-button">

                Jetzt anrufen - 24/7 verfügbar
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Calendar"
                iconPosition="left"
                className="border-white text-white hover:bg-white hover:text-primary">

                Beratung vereinbaren
              </Button>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="flex items-center justify-center w-16 h-16 bg-trust-builder rounded-full">
                    <Icon name="Award" size={28} color="white" strokeWidth={2} />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white">Zertifizierte Expertise</h3>
                    <p className="text-white/80">Zugelassene Rechtsanwälte</p>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-conversion-accent">24/7</div>
                    <div className="text-sm text-white/80">Verfügbarkeit</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-conversion-accent">2,99€</div>
                    <div className="text-sm text-white/80">pro Minute</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;